import React, { useRef, useState, useEffect } from "react";

import {
  FileUploadContainer,
  FormField,
  DragDropText,
  UploadFileBtn,
  FilePreviewContainer,
  ImagePreview,
  PreviewContainer,
  PreviewList,
  FileMetaData,
  RemoveFileIcon,
  InputLabel
} from "./file-upload.styles";

import upload from "../../assets/img/upload.png";
const KILO_BYTES_PER_BYTE = 1000;
const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 10000000;

const convertNestedObjectToArray = (nestedObj) =>
  Object.keys(nestedObj).map((key) => nestedObj[key]);

const convertBytesToKB = (bytes) => Math.round(bytes / KILO_BYTES_PER_BYTE);

const FileUpload = ({
  label,
  updateFilesCb,
 updateFilesAuthorised,
  maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  oldvalue,
  ...otherProps
}) => {
  const fileInputField = useRef(null);
  const [files, setFiles] = useState(oldvalue);


useEffect(() => {
  setFiles(oldvalue);
}, [oldvalue]);


  const addNewFiles = (newFiles) => {
    for (let file of newFiles) {
      if (file.size <= maxFileSizeInBytes) {
        if (!otherProps.multiple) {
          return { file };
        }
        files[file.name] = file;
      }
    }
    return { ...files };
  };

  const callUpdateFilesCb = (files,filename,checked) => {
    const filesAsArray = convertNestedObjectToArray(files);
    updateFilesCb(filesAsArray,filename,checked);
  };

  const handleNewFileUpload = async (e) => {

    const { files: newFiles } = e.target;
    if (newFiles.length) {
      let updatedFiles = addNewFiles(newFiles);
      setFiles(updatedFiles);
      callUpdateFilesCb(updatedFiles);
    }

  };

  const removeFile = async (fileName,fileid) => {
    if(window.confirm("do you want to delete the file!")){
       delete files[fileName];
        setFiles({ ...files });
        callUpdateFilesCb({ ...files });
    }


  };



  const handleCheck = async (index,checked,filename) =>{



    const mappedDataArray = [];

    debugger
    for (const key in files) {
      const mappedData = {
        ...files[key]
      };
      mappedDataArray.push(mappedData);
    }
    debugger
    let updated ={...files};

    debugger
    if(updated[index]){
      updated[index].authorized = checked;
    }else{
      // new file

    }


    debugger
    setFiles(updated)


    updateFilesAuthorised(index,checked);

  }

  return (
    <>
      <FileUploadContainer>
        <InputLabel>{label}</InputLabel>

        <DragDropText>File types allowed: jpg,.png,.jpeg,.pdf,.doc,.docx,.xls,.xlsx (MAX:10MB) </DragDropText>
        <img src={upload} style={{width:100}} />


         <form>

        <FormField
          type="file"
          ref={fileInputField}
          onChange={handleNewFileUpload}
          title=""
          value=""
          {...otherProps}
        />
          </form>

      </FileUploadContainer>
      <FilePreviewContainer>
        <span>To Upload</span>
        <PreviewList>
          {Object.keys(files).map((fileName, index) => {
            let file = files[fileName];
            let isImageFile= false;
            if(file.type){
              isImageFile = file.type.split("/")[0] === "image";
            }
            return (
              <PreviewContainer key={fileName}>
                <div>
                  {isImageFile && (
                    <ImagePreview
                      src={URL.createObjectURL(file)}
                      alt={`file preview ${index}`}
                    />
                  )}
                  <FileMetaData isImageFile={isImageFile}>
                    <span onClick={() => window.open(file.url)} className="cursor">{file.name} (click me to open the document)</span>
                    <aside>
                      <span>Authorized<input type="checkbox" name="authorized" value={file.id} onChange={(e) => handleCheck(index,e.target.checked,file.name)} checked={file.authorized} /></span>

                      <RemoveFileIcon
                        className="fas fa-trash-alt"
                        onClick={() => removeFile(fileName,file.id)}
                      >delete
                      </RemoveFileIcon>
                    </aside>
                  </FileMetaData>
                </div>
              </PreviewContainer>
            );
          })}
        </PreviewList>
      </FilePreviewContainer>
    </>
  );
};

export default FileUpload;
